// API endpoints
export const API_ENDPOINTS = {
  ACCOUNT: {
    PAGE: "/auth/api/v1/manager/account/page",
    CREATE: "/auth/api/v1/manager/account/create",
    UPDATE: "/auth/api/v1/manager/account/update",
    DELETE: "/auth/api/v1/manager/account/delete",
    CHANGE_PASSWORD: "/auth/api/v1/manager/account/pwd/change",
    GET_ROLES: "/auth/api/v1/manager/account/roles",
    ASSIGN_ROLES: "/auth/api/v1/manager/account/authorize",
    REMOVE_ROLES: "/auth/api/v1/manager/account/authorize/remove",
    APPROVE: "/wms/api/v1/management/approval/action",
    REJECT: "/wms/api/v1/management/approval/action",
    ENABLE: "/auth/api/v1/manager/account/enable",
    DISABLE: "/auth/api/v1/manager/account/disable",
    STORE_ACCOUNTS: "/auth/api/v1/manager/account/store/accounts",
    UPDATE_PROFICIENCY: "/wms/labor/v1/management/proficiency/update-level",
  },
  AUTH: {
    LOGIN: "/auth/api/v1/login/do-login",
    SSO_LOGIN: "/auth/api/v1/sso/login",
    SSO_CONFIG: "/auth/api/v1/sso/config",
    SSO_CALLBACK: "/auth/api/v1/sso/callback",
    ACCOUNT_INFO: "/auth/api/v1/account/info",
    LIST_ACCOUNT: "/auth/api/v1/manager/account/options",
    STORE_USERS: "/wms/api/user/store-users",
    USER_INFO: "/wms/api/auth/userInfo",
    RESET_PASSWORD: "/auth/api/v1/login/account/pwd/update",
    UPDATE_WAREHOUSE: "/wms/api/auth/updateCurrentWarehouse",
    MENU_TREE: "/auth/api/v1/account/menu/tree",
  },
  ROLE: {
    PAGE: "/auth/api/v1/manager/role/page",
    CURRENT_AUTHED: "/auth/api/v1/manager/role/current/authed",
    CREATE: "/auth/api/v1/manager/role/create",
    UPDATE: "/auth/api/v1/manager/role/update",
    DELETE: "/auth/api/v1/manager/role/delete",
    UPDATE_MENU_PERMISSIONS: "/auth/api/v1/manager/role/authorize",
    REMOVE_MENU_PERMISSIONS: "/auth/api/v1/manager/role/authorize/remove",
    QUERY_AUTHED_PERMISSIONS: "/auth/api/v1/manager/role/authed/menu/tree",
  },
  MENU: {
    TREE: "/auth/api/v1/manager/menu/tree",
    CREATE: "/auth/api/v1/manager/menu/create",
    UPDATE: "/auth/api/v1/manager/menu/update",
    DELETE: "/auth/api/v1/manager/menu/delete",
  },
  DATA_PERMISSION: {
    PAGE: "/auth/api/v1/manager/data-pms/page",
    CREATE: "/auth/api/v1/manager/data-pms/create",
    UPDATE: "/auth/api/v1/manager/data-pms/update",
    DELETE: "/auth/api/v1/manager/data-pms/delete",
  },
  STORE: {
    PAGE: "/wms/api/store/page",
    LIST: "/wms/api/store/multi-query",
    IMPORT: "/wms/api/store/import",
    EXPORT: "/wms/api/store/export",
  },
  PERSONNEL: {
    PAGE_LEVELS: "/wms/api/v1/personnel/level/page",
    LIST_LEVELS: "/wms/api/v1/personnel/level/list",
    CREATE_LEVEL: "/wms/api/v1/personnel/level/create",
    UPDATE_LEVEL: "/wms/api/v1/personnel/level/update",
    DELETE_LEVEL: "/wms/api/v1/personnel/level/delete",
    QUERY_PERSONNEL: "/wms/api/v1/personnel/list",
    GET_BOUND: "/wms/api/v1/personnel/level/bound",
    BIND: "/wms/api/v1/personnel/level/bind",
    GET_ORDER_COMPLEXITY: "/wms/api/v1/personnel/order-complexity/get",
    UPDATE_ORDER_COMPLEXITY: "/wms/api/v1/personnel/order-complexity/update",
  },
  ORDER: {
    PAGE: "/wms/api/v1/order/order/page",
    BASE: "/wms/api/v1/order/order",
    EXPORT: "/wms/api/v1/order/order/export",
    DECRYPT_DETAIL: "/wms/api/v1/order/order/decrypt-detail",
    RETURN_ORDER_PAGE: "/wms/api/v1/order/return-order/page",
    RETURN_ORDER_BASE: "/wms/api/v1/order/return-order",
    RETURN_ORDER_OPTION: "/wms/api/v1/order/return-order/option",
    RETURN_ORDER_EXPORT: "/wms/api/v1/order/return-order/export",
    SHORTAGE_ORDER_PAGE: "/wms/api/v1/order/shortage-order/page",
    SHORTAGE_ORDER_BASE: "/wms/api/v1/order/shortage-order",
    SHORTAGE_ORDER_EXPORT: "/wms/api/v1/order/shortage-order/export",
    SUBSTITUTE_RECORD_PAGE: "/wms/api/v1/order/substitute-record/page",
    SUBSTITUTE_RECORD_EXPORT: "/wms/api/v1/order/substitute-record/export",
  },
  PICKING_TASK: {
    PAGE: "/wms/api/v1/picking/picking-task/page",
    BASE: "/wms/api/v1/picking/picking-task",
    ASSIGN: "/wms/api/v1/picking/picking-task/assign",
    EXPORT: "/wms/api/v1/picking/picking-task/export",
  },
  PICKING_STRATEGY: {
    CONFIG_BASE: "/wms/api/v1/picking-strategy/config",
    CONFIG_SAVE: "/wms/api/v1/picking-strategy/config/save",
  },
  INVENTORY: {
    STOCK_PAGE: "/wms/api/v1/inventory/stock/page",
    STOCK_BASE: "/wms/api/v1/inventory/stock",
    STOCK_EXPORT: "/wms/api/v1/inventory/stock/export",
    CATEGORY_OPTIONS: "/wms/api/v1/inventory/stock/category/options",
  },
  CATEGORY: {
    PAGE: "/wms/api/v1/master-data/category/page",
    TREE: "/wms/api/v1/master-data/category/tree",
  },
  ITEM: {
    PAGE: "/wms/api/item/page",
    BASE: "/wms/api/item",
    UPDATE_WEIGHT_LIMIT: "/wms/api/item/update-weight-limit",
    UPDATE: "/wms/api/item/update",
    SYNC: "/wms/api/item/sync",
    EXPORT: "/wms/api/item/export",
    IMPORT: "/wms/api/item/import",
    OPTION: "/wms/api/item/option",
  },
  SORTING: {
    PAGE: "/api/v1/sorting/sorting-task/page",
    BASE: "/api/v1/sorting/sorting-task",
  },
  WAVE_RULE: {
    PAGE: "/wms/api/v1/wave/wave-rule/page",
    BASE: "/wms/api/v1/wave/wave-rule",
    CREATE: "/wms/api/v1/wave/wave-rule/create",
    UPDATE: "/wms/api/v1/wave/wave-rule/update",
    ENABLE: "/wms/api/v1/wave/wave-rule/enable",
    DISABLE: "/wms/api/v1/wave/wave-rule/disable",
    DELETE: "/wms/api/v1/wave/wave-rule/delete",
  },
  WAVE_INSTANCE: {
    PAGE: "/wms/api/v1/wave/wave-instance/page",
    BASE: "/wms/api/v1/wave/wave-instance",
    TRIGGER: "/wms/api/v1/wave/wave-instance/trigger",
  },
  WAVE_CONFIG_LOG: {
    PAGE: "/wms/api/v1/wave/wave-config-log/page",
  },
  LOCATION: {
    PAGE: "/wms/api/v1/store-resource/location/page",
    BASE: "/wms/api/v1/store-resource/location",
    EXPORT: "/wms/api/v1/store-resource/location/export",
    IMPORT: "/wms/api/v1/store-resource/location/import",
  },
  SUBSTITUTE_RULE: {
    PAGE: "/wms/api/v1/master-data/substitution-rule/page",
    BASE: "/wms/api/v1/master-data/substitution-rule",
    CREATE: "/wms/api/v1/master-data/substitution-rule/create",
    UPDATE: "/wms/api/v1/master-data/substitution-rule/update",
    ENABLE: "/wms/api/v1/master-data/substitution-rule/enable",
    DISABLE: "/wms/api/v1/master-data/substitution-rule/disable",
    DELETE: "/wms/api/v1/master-data/substitution-rule/delete",
    BATCH_DELETE: "/wms/api/v1/master-data/substitution-rule/batch-delete",
    CATEGORY_TREE: "/wms/api/v1/master-data/substitution-rule/category-tree",
  },
  REPORT: {
    SLA_FULFILLMENT_PAGE: "/wms/api/v1/report/sla-fulfillment/page",
    SLA_FULFILLMENT_EXPORT: "/wms/api/v1/report/sla-fulfillment/export",
    SLA_CHANNEL_OPTION: "/wms/api/v1/report/sla-fulfillment/channel/option",
    SLA_PAYMENT_METHOD_OPTION: "/wms/api/v1/report/sla-fulfillment/payment-method/option",
    PAYMENT_INVOICE_PAGE: "/wms/api/v1/report/payment-invoice/page",
    COD_RECONCILIATION_PAGE: "/wms/api/v1/report/cod-reconciliation/page",
    COD_RECONCILIATION_EXPORT: "/wms/api/v1/report/cod-reconciliation/export",
    COD_RECONCILIATION_RIDER_OPTION: "/wms/api/v1/report/cod-reconciliation/rider-option",
  },
  DASHBOARD: {
    OVERVIEW: "/wms/api/v1/dashboard/overview",
    DEMAND_VOLUME: "/wms/api/v1/order/dashboard/demand-volume",
    OUTPUT_THROUGHPUT: "/wms/api/v1/order/dashboard/output-throughput",
    ORDER_FLOW_STATUS: "/wms/api/v1/order/dashboard/order-flow-status",
    SLA_FULFILLMENT: "/wms/api/v1/order/dashboard/sla-fulfillment",
    PROCESSING_TIME: "/wms/api/v1/order/dashboard/processing-time",
    QUALITY_STOCK: "/wms/api/v1/order/dashboard/quality-stock",
    QUALITY_STOCK_ITEM_REASONS: "/wms/api/v1/order/dashboard/quality-stock/item-shortage-reasons",
    FINANCIAL: "/wms/api/v1/order/dashboard/financial",
    CANCELLATION: "/wms/api/v1/order/dashboard/cancellation",
    WORKFORCE: "/wms/api/v1/order/dashboard/workforce",
  },
  NATIONWIDE_DASHBOARD: {
    EXECUTIVE_SUMMARY: "/wms/api/v1/order/dashboard/national/executive-summary",
    REALTIME_OPERATIONS: "/wms/api/v1/order/dashboard/national/realtime-operations",
    RANKINGS: "/wms/api/v1/order/dashboard/national/rankings",
  },
  NOTIFICATION: {
    RECORD_PAGE: "/wms/api/v1/notification/notification-record/page",
    RECORD_BASE: "/wms/api/v1/notification/notification-record",
    RECORD_RESEND: "/wms/api/v1/notification/notification-record/resend",
    RECORD_MARK_READ: "/wms/api/v1/notification/notification-record/mark-read",
    RECORD_MARK_ALL_READ: "/wms/api/v1/notification/notification-record/mark-all-read",
    RECORD_UNREAD_COUNT: "/wms/api/v1/notification/notification-record/unread-count",
    SEND: "/wms/api/v1/notification/send",
    STATISTICS: "/wms/api/v1/notification/statistics",
    TEMPLATE_PAGE: "/wms/api/v1/notification/notification-template/page",
    TEMPLATE_UPDATE: "/wms/api/v1/notification/notification-template/update",
    SSE_SUBSCRIBE: "/wms/api/v1/notification/sse/subscribe",
    SSE_DISCONNECT: "/wms/api/v1/notification/sse/disconnect",
  },
};